import React from 'react';
import { Box, Button } from '@amzn/awsui-components-react';
import { handleSignIn } from '../../utils/authUtils';

const SignInButton = ({ primary, idp, localeData }) => {
  return (
    <Box margin={{ bottom: 's' }}>
      <Button
        variant={primary ? 'primary' : 'normal'}
        onClick={() => handleSignIn(idp)}
      >
        {localeData.label}
      </Button>
    </Box>
  );
};

export default SignInButton;
